import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "@/lib/api";

export default function VerifyCertificate() {
  const { code } = useParams();
  const [cert, setCert] = useState(undefined); // undefined = loading, null = not found

  useEffect(() => {
    api.get(`/verify/${code}`).then((r) => setCert(r.data)).catch(() => setCert(null));
  }, [code]);

  return (
    <div className="auth on-dark" style={{ alignItems: "flex-start", paddingTop: "60px" }}>
      <div style={{ width: "100%", maxWidth: "760px" }}>
        <div className="auth__brand" style={{ justifyContent: "center", marginBottom: "26px" }}>
          <span className="nav__logo">EQUIPR</span>
          <span style={{ color: "var(--eq-white)", fontWeight: "var(--fw-bold)", fontSize: "var(--fs-body-lg)" }}>Academy</span>
        </div>

        {cert === undefined && <div className="loading" style={{ color: "var(--label-on-dark)" }}>Verifying…</div>}

        {cert === null && (
          <div className="cert" data-testid="verify-notfound">
            <div className="cert__kicker">Academy · Certificate</div>
            <div className="cert__title" style={{ color: "var(--text-ink)" }}>No certificate matches this code.</div>
            <p className="cert__lead" style={{ marginTop: "12px" }}>Check the verification code and try again.</p>
          </div>
        )}

        {cert && (
          <div className="cert" data-testid="verify-card">
            <span className="cert__mark">EQUIPR</span>
            <div className="cert__kicker">Academy · Verified certificate</div>
            <p className="cert__lead">This certifies that</p>
            <div className="cert__name">{cert.learnerName}</div>
            <p className="cert__lead">has completed the</p>
            <div className="cert__title">{cert.productName} — {cert.roleName} Certification</div>
            <div className="cert__meta">
              <div><div className="cert__meta-label">Issued</div><div className="cert__meta-value">{cert.issuedDate}</div></div>
              <div><div className="cert__meta-label">Product version</div><div className="cert__meta-value">{cert.productTag} · {cert.guideVersion}</div></div>
              <div><div className="cert__meta-label">Code</div><div className="cert__meta-value">{cert.verifyCode}</div></div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
